import './App.css';
import Folder from './components/Folder';

function App() {
  return (
    <div className="App">
      <Folder />
    </div>
  );
}

export default App;
